var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{directives:[{name:"editable",rawName:"v-editable",value:(_vm.cms),expression:"cms"}],class:[_vm.name, _vm.spacing],style:(_vm.mainCssVars),attrs:{"id":`${_vm.cms.scroll_id}`}},[_c('grid',{class:[`${_vm.name}__grid`],attrs:{"layout":[
      {
        size: 1,
        columns: 'repeat(12, 1fr)',
        gap: '6px',
      },
      {
        size: 2,
        columns: 'repeat(24, 1fr)',
        gap: '10px',
      },
    ]}},[_c('grid-item',{class:[`${_vm.name}__grid-item`, `${_vm.name}__media`],attrs:{"layout":[
        { size: 1, x: 1, width: 12, y: 1, height: 1 },
        { size: 3, x: 1, width: 24, y: 1, height: 1 },
      ]}},[_c('transition',{attrs:{"name":"fade"}},[_c('m-media',{attrs:{"cms":_vm.cms,"layout":[
            { size: 0, bound: 667, ratio: [375, 667] },
            { size: 1, bound: 768, ratio: [1480, 833] },
            { size: 2, bound: 992, ratio: [1480, 833] },
            { size: 3, bound: 1200, ratio: [1480, 833] },
            { size: 4, bound: 1440, ratio: [1480, 833] },
          ]}})],1)],1),_vm._v(" "),_c('grid-item',{class:[`${_vm.name}__grid-item`, `${_vm.name}__caption`],attrs:{"layout":[
        { size: 1, x: 1, width: 12, y: 1, height: 1 },
        { size: 3, x: 1, width: 24, y: 1, height: 1 },
      ]}},[_c('grid',{class:['grid--container', `${_vm.name}__grid`],attrs:{"html-tag":`figcaption`,"layout":[
          {
            size: 1,
            columns: 'repeat(12, 1fr)',
            gap: '6px',
          },
          {
            size: 2,
            columns: 'repeat(24, 1fr)',
            gap: '10px',
          },
        ]}},[_c('grid-item',{class:`${_vm.name}__grid-item`,attrs:{"layout":[
            { size: 1, x: 1, width: 12 },
            { size: 2, x: 1, width: 24 },
            { size: 3, x: 1, width: 24 },
            { size: 4, x: 1, width: 24 },
          ]}},[(_vm.cms.heading)?_c('m-section-header-v2',{class:`${_vm.name}__header`,attrs:{"cms":_vm.cms}}):_vm._e(),_vm._v(" "),_c('div',{class:`${_vm.name}__collection`},_vm._l((_vm.cms.clients),function(item,index){return _c('a-link-v2',{key:index,class:[`${_vm.name}__item`, _vm.getClass(index + 1)],attrs:{"href":item.href ? item.href.url : ''}},[(_vm.show && (item.image || {}).filename)?_c('a-image-v2',{class:`${_vm.name}__image`,attrs:{"src":item.image.filename,"alt":item.image.alt,"layout":[
                  { size: 0, bound: 150, ratio: [150, 150] },
                  { size: 1, bound: 150, ratio: [150, 150] },
                  { size: 2, bound: 150, ratio: [150, 150] },
                  { size: 3, bound: 206, ratio: [206, 206] },
                ]}}):_vm._e()],1)}),1)],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }